import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { orderBy } from 'lodash';
import { ProgramConsumer } from '../../contexts/ProgramContext';
import ProgramCard from './components/ProgramCard';

import './Program.scss';

export const Program = ({
  loadProgram,
  talks,
  selectedTalk,
  speakers,
  setSelectedTalk,
  isLoading
}) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    loadProgram();
    if (history.action !== 'POP') {
      window.scrollTo(0, 0);
      setSelectedTalk('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderDayColumn = (column, day, streams) => {
    const orderedSlots = column.length > 0 ? orderBy(column, ['startTime'], 'asc') : [];
    let dayTitle = '';
    let dayDate = '';
    let dayTrack = '';
    switch (day) {
      case 'day1_0':
        dayTitle = 'Tuesday';
        dayDate = 'Oct. 19th';
        dayTrack = streams.day1 ? 'Stream 1' : '';
        break;
      case 'day1_1':
        dayTitle = 'Tuesday';
        dayDate = 'Oct. 19th';
        dayTrack = streams.day1 ? 'Stream 2' : '';
        break;
      case 'day2_0':
        dayTitle = 'Wednesday';
        dayDate = 'Oct. 20th';
        dayTrack = streams.day2 ? 'Stream 1' : '';
        break;
      case 'day2_1':
        dayTitle = 'Wednesday';
        dayDate = 'Oct. 20th';
        dayTrack = streams.day2 ? 'Stream 2' : '';
        break;
      case 'day3_0':
        dayTitle = 'Thursday';
        dayDate = 'Oct. 21st';
        dayTrack = streams.day3 ? 'Stream 1' : '';
        break;
      case 'day3_1':
        dayTitle = 'Thursday';
        dayDate = 'Oct. 21st';
        dayTrack = streams.day3 ? 'Stream 2' : '';
        break;
      default:
        dayTitle = 'Tuesday';
        dayDate = 'Oct. 19th';
        dayTrack = '';
        break;
    }
    const classes =
      location.pathname === '/program' && day.includes('day2') ? 'column is-half-tablet' : 'column';
    return (
      <div key={day} className={classes}>
        <h2 className={`day-title ${day}-color`}>
          {dayTitle}
          <br />
          <span className="day-date">{dayDate}</span>
        </h2>
        <h2 className="day-subtitle">{dayTrack}</h2>
        {orderedSlots.map((slot, index) => {
          const speakerNames = [];
          if (slot.speakers) {
            slot.speakers.forEach(speakerId => {
              const foundSpeaker = speakers.find(sp => sp.id === speakerId) || {};
              if (foundSpeaker && foundSpeaker.name) {
                speakerNames.push(foundSpeaker.name);
              }
            });
          }
          if (day === 'day1_0' && index === 0 && location.pathname === '/program') {
            return (
              <div key="opening-talks">
                <ProgramCard
                  key="opening"
                  color={`${day}-color`}
                  endTime="15:15"
                  speakerNames={['Tomáš Volek']}
                  startTime="15:00"
                  talk={{
                    title: 'Conference Opening',
                    youtube: 'https://www.youtube.com/watch?v=f9x2ALyjLM0'
                  }}
                  tileRole=""
                />
                <ProgramCard
                  key={slot.id}
                  color={`${day}-color`}
                  endTime={slot.endTime}
                  id={slot.id}
                  onCardClick={setSelectedTalk}
                  selectedTalk={selectedTalk}
                  speakerNames={speakerNames}
                  startTime={slot.startTime}
                  talk={{ title: slot.title, youtube: slot.youtube }}
                  tileRole=""
                />
              </div>
            );
          }
          if (
            day.includes('day2') &&
            slot.startTime === '15:40' &&
            location.pathname === '/program'
          ) {
            return (
              <div key="opening-talks">
                {/* <ProgramCard
                  key="opening"
                  color={`${day}-color`}
                  endTime="15:40"
                  speakerNames={[]}
                  startTime="15:30"
                  talk={{ title: 'Opening' }}
                  tileRole=""
                /> */}
                <ProgramCard
                  key={slot.id}
                  color={`${day}-color`}
                  endTime={slot.endTime}
                  id={slot.id}
                  onCardClick={setSelectedTalk}
                  selectedTalk={selectedTalk}
                  speakerNames={speakerNames}
                  startTime={slot.startTime}
                  talk={{ title: slot.title, youtube: slot.youtube }}
                  tileRole=""
                />
              </div>
            );
          }
          return (
            <ProgramCard
              key={slot.id}
              color={`${day}-color`}
              endTime={slot.endTime}
              id={slot.id}
              onCardClick={setSelectedTalk}
              selectedTalk={selectedTalk}
              speakerNames={speakerNames}
              startTime={slot.startTime}
              talk={{ title: slot.title, youtube: slot.youtube }}
              tileRole=""
            />
          );
        })}
      </div>
    );
  };

  const renderProgram = () => {
    const wftTalkfilter = talks.filter(talk => talk.id !== '490adbb9-b92a-4213-8a77-d06ea7265d4e');
    const filteredTalks =
      location.pathname === '/program'
        ? wftTalkfilter.filter(talk => talk.track === 'Talk')
        : wftTalkfilter.filter(talk => talk.track !== 'Talk');
    // add if track value is zero or undefined
    const day1_0 = filteredTalks.filter(talk => talk.conferenceDay === 'day1' && !talk.trackInDay);
    const day1_1 = filteredTalks.filter(
      talk => talk.conferenceDay === 'day1' && talk.trackInDay === 1
    );
    const day2_0 = filteredTalks.filter(talk => talk.conferenceDay === 'day2' && !talk.trackInDay);
    const day2_1 = filteredTalks.filter(
      talk => talk.conferenceDay === 'day2' && talk.trackInDay === 1
    );
    const day3_0 = filteredTalks.filter(talk => talk.conferenceDay === 'day3' && !talk.trackInDay);
    const day3_1 = filteredTalks.filter(
      talk => talk.conferenceDay === 'day3' && talk.trackInDay === 1
    );
    // value if day has 2 streams
    const dayStream = {
      day1: day1_1.length > 0,
      day2: day2_1.length > 0,
      day3: day3_1.length > 0
    };
    const program = {
      day1_0,
      day1_1,
      day2_0,
      day2_1,
      day3_0,
      day3_1
    };
    const programDays = [];
    const programKeys = Object.keys(program);
    programKeys.forEach(key => {
      if (program[key].length) programDays.push(key);
    });
    const programExists = programDays.length > 0;

    const doubleCol = 'is-6 is-full-touch is-full-tablet';
    const singleCol = 'is-3 is-12-touch is-half-tablet';
    const colClasses = 'column';
    const day1Class = dayStream.day1 ? doubleCol : singleCol;
    const day2Class = dayStream.day2 ? doubleCol : singleCol;
    const day3Class = dayStream.day3 ? doubleCol : singleCol;
    const classes = 'columns is-desktop';
    return (
      <div className="program-wrapper is-full">
        {programExists ? (
          <>
            {/* {location.pathname === '/workshops' ? (
              <h2 className="subtitle">Registrations for workshops coming soon.</h2>
            ) : null} */}
            {/* <h2 className="subtitle">All times are in CET (GMT+2) time zone</h2> */}
            <div className={classes}>
              <div className={`${colClasses} ${day1Class}`}>
                <div className="columns is-multiline ">
                  {/* {programDays.map(day => renderDayColumn(program[day], day, dayStream))} */}
                  {renderDayColumn(program.day1_0, 'day1_0', dayStream)}
                  {program.day1_1.length
                    ? renderDayColumn(program.day1_1, 'day1_1', dayStream)
                    : null}
                </div>
              </div>
              <div className={`${colClasses} ${day2Class}`}>
                <div className="columns is-multiline">
                  {/* {programDays.map(day => renderDayColumn(program[day], day, dayStream))} */}
                  {renderDayColumn(program.day2_0, 'day2_0', dayStream)}
                  {program.day2_1.length
                    ? renderDayColumn(program.day2_1, 'day2_1', dayStream)
                    : null}
                </div>
              </div>
              <div className={`${colClasses} ${day3Class}`}>
                <div className="columns is-multiline ">
                  {/* {programDays.map(day => renderDayColumn(program[day], day, dayStream))} */}
                  {renderDayColumn(program.day3_0, 'day3_0', dayStream)}
                  {program.day3_1.length
                    ? renderDayColumn(program.day3_1, 'day3_1', dayStream)
                    : null}
                </div>
              </div>
            </div>
          </>
        ) : (
          <h2 className="subtitle">There is no program at this time, stay tuned.</h2>
        )}
      </div>
    );
  };

  return (
    <section className="section" id="program-section">
      <div className="container">
        <h1 className="column">{location.pathname === '/program' ? 'PROGRAM' : 'HANDS-ON LABS'}</h1>
        {/* <h2 className="subtitle">
          Take a look at the preliminary program below. Please note that it is not yet finalized and
          is subject to change.
        </h2> */}
        {!isLoading ? (
          renderProgram()
        ) : (
          <i className="fa fa-spinner fa-spin fa-3x fa-fw" style={{ color: '#7500c0' }} />
        )}
      </div>
    </section>
  );
};

Program.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadProgram: PropTypes.func.isRequired,
  selectedTalk: PropTypes.string.isRequired,
  setSelectedTalk: PropTypes.func.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  talks: PropTypes.arrayOf(PropTypes.any).isRequired
};

const ProgramContainer = (...props) => (
  <ProgramConsumer>
    {({ loadProgram, talks, selectedTalk, speakers, setSelectedTalk, isLoading }) => (
      <Program
        isLoading={isLoading}
        loadProgram={loadProgram}
        selectedTalk={selectedTalk}
        setSelectedTalk={setSelectedTalk}
        speakers={speakers}
        talks={talks}
        {...props}
      />
    )}
  </ProgramConsumer>
);

export default ProgramContainer;
